import React, {FC} from "react";
import {Grid} from "@mui/material";
import {TextInfoItem} from "../../table/TextInfoItem";
import {GetSvgIcon} from "../../GetSvgIcon";
import {IconNames} from "../../../enums/Icons";
import {IdlocaGeneric} from "../../../locales/IdlocaGeneric";
import {IMotorcycle} from "../../../interfaces/Interfaces";

const iconStyle = {width: 14, height: 14, color: "#888888"};

interface IMotorcycleInfo {
    motorcycle: IMotorcycle;
}

export const MotorcycleInfo: FC<IMotorcycleInfo> = ({motorcycle}) => {
    return (
        <Grid container>
            <Grid item xs={6} sm={6}>
                <TextInfoItem
                    toolTipLocaId={IdlocaGeneric.type}
                    value={motorcycle.typeName}
                    icon={<GetSvgIcon name={IconNames.MoTorCycle} style={iconStyle}/>}
                />
            </Grid>
            <Grid item xs={6} sm={6}>
                <TextInfoItem
                    toolTipLocaId={IdlocaGeneric.year}
                    value={motorcycle.year}
                    icon={<GetSvgIcon name={IconNames.Date} style={iconStyle}/>}
                />
            </Grid>
            <Grid item xs={6} sm={6}>
                <TextInfoItem
                    toolTipLocaId={IdlocaGeneric.engine_size}
                    value={motorcycle.engineSize}
                    icon={<GetSvgIcon name={IconNames.Engine} style={iconStyle}/>}
                />
            </Grid>
            <Grid item xs={6} sm={6}>
                <TextInfoItem
                    value={motorcycle.gearbox}
                    icon={<GetSvgIcon name={IconNames.Gearbox} style={iconStyle}/>}
                />
            </Grid>
            <Grid item xs={6} sm={6}>
                <TextInfoItem
                    toolTipLocaId={IdlocaGeneric.topSpeed}
                    value={motorcycle.topSpeed}
                    icon={<GetSvgIcon name={IconNames.Speed} style={iconStyle}/>}
                />
            </Grid>
            <Grid item xs={6} sm={6}>
                <TextInfoItem
                    toolTipLocaId={IdlocaGeneric.coolingSystem}
                    value={motorcycle.coolingSystem}
                    icon={<GetSvgIcon name={IconNames.Fan} style={iconStyle}/>}
                />
            </Grid>
        </Grid>
    );
};


